import { toast } from 'react-toastify';

const options = {
  position: toast.POSITION.BOTTOM_RIGHT,
  autoClose: 4000,
  hideProgressBar: false,
  pauseOnHover: true,
};

export const successToast = (text) =>
  toast.success(text, {
    ...options,
    type: toast.TYPE.SUCCESS,
    className: 'success-toast',
  });

export const infoToast = (text) =>
  toast.info(text, {
    ...options,
    type: toast.TYPE.INFO,
  });

export const errorToast = (text) =>
  toast.error(text, {
    ...options,
    type: toast.TYPE.ERROR,
    className: 'error-toast',
  });

export const defaultToast = (text, opt = {}) => toast(text, { ...options, ...opt });
